export default __webpack_public_path__ + "static/media/Ape.4cf00f7f.jpg";